<template>
  <div>
    <OfferRejected :product="BRAND.loan" />
  </div>
</template>

<script>
import OfferRejected from "@/forms/components/loan/stp-loan/forms/offer-rejected";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import BRAND from "@/forms/constants/brand";

export default {
  name: "OnboardDunia",

  components: {
    OfferRejected
  },

  data: () => ({
    BRAND
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  }
};
</script>

